import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-arrow-100",
  "use": "app-icon-arrow-100-usage",
  "viewBox": "0 0 151 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 151 16\" id=\"app-icon-arrow-100\"><g fill=\"#3DCCA6\" fill-rule=\"evenodd\"><path d=\"M0 5.5h140v6H0zM151 8.5l-11 8V.5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol